import { ehFilaEsclarecimento } from '@/features/encerramento-processo';

import type { FilaPrazo, PrazoEnriquecido, PrazoPainelApiItem } from '../types';

export function mapearFila(tipo: string): FilaPrazo {
  const t = tipo
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase();
  if (t.includes('TRIAGEM') || t.includes('ADMISSIBILIDADE')) return 'TRIAGEM';
  if (t.includes('CONTESTACAO') || t.includes('DECURSO')) return 'DECURSO_CONTESTACAO';
  if (t.includes('PAGAMENTO') || t.includes('CUSTAS')) return 'PAGAMENTO';
  if (t.includes('IMPARCIALIDADE') || t.includes('TERMO')) return 'POS_NOMEACAO';
  if (t.includes('SORTEIO') || t.includes('DISTRIBUICAO') || t.includes('NOMEACAO'))
    return 'DISTRIBUICAO';
  if (ehFilaEsclarecimento(t)) return 'ESCLARECIMENTO';
  if (t.includes('SENTENCA')) return 'SENTENCA';
  if (t.includes('TRANSITO')) return 'TRANSITO';
  if (t.includes('MANIFESTACAO')) return 'MANIFESTACAO';
  if (
    t.includes('INSTRUCAO') ||
    t.includes('CONCLUSO') ||
    t.includes('DILIGENCIA') ||
    t.includes('DECISAO') ||
    t.includes('INTERLOCUTORIA') ||
    t.includes('QUANTIFICACAO')
  )
    return 'INSTRUCAO';
  if (t.includes('CITACAO') || t.includes('INTIMACAO') || t.includes('OFICIO')) return 'CITACAO';
  return 'OUTROS';
}

export function mapearPrazoApi(item: PrazoPainelApiItem): PrazoEnriquecido {
  return {
    id: item.id,
    origem: item.origem,
    processoArbitralId: item.processoArbitralId,
    numeroProcesso: item.numeroProcesso,
    tipo: item.tipo,
    titulo: item.titulo,
    descricao: item.descricao ?? null,
    dataVencimento: item.dataVencimento,
    diasParaVencer: item.diasParaVencer,
    status: item.status,
    responsavelTipo: item.responsavelTipo,
    papel: item.responsavelTipo,
    papelParte: item.papelParte,
    // O retorno do AR é a carta de citação: vai para a fila "Citação / AR", que não se deduz
    // pelo nome ("AR" como substring casaria com metade do vocabulário).
    fila: item.origem === 'AR' ? 'CITACAO' : mapearFila(item.tipo),
    arbitroNome: item.arbitroNome,
    statusArbitral: item.statusArbitral,
    partes: item.partes,
  };
}
